import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.utiliti.ng";

// Create axios instance with authentication
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for authentication
axiosInstance.interceptors.request.use(
  (config) => {
    const user = localStorage.getItem('user');
    let token = '';
    if (user) {
      try {
        token = JSON.parse(user).token;
      } catch (e) { }
    }
    if (token) {
      config.headers['x-auth-token'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const eventDesignService = {
  // Get all design templates
  getAllTemplates: async (params = {}) => {
    const { page = 1, limit = 20, isActive } = params;
    const queryParams = new URLSearchParams();
    if (page) queryParams.append('page', page);
    if (limit) queryParams.append('limit', limit);
    if (isActive !== undefined) queryParams.append('isActive', isActive);

    const response = await axiosInstance.get(
      `/api/admin/design-templates?${queryParams.toString()}`
    );
    return response.data;
  },

  // Get template by ID
  getTemplateById: async (templateId) => {
    const response = await axiosInstance.get(
      `/api/admin/design-templates/${templateId}`
    );
    return response.data;
  },

  // Get default template
  getDefaultTemplate: async () => {
    const response = await axiosInstance.get(
      `/api/admin/design-templates/default`
    );
    return response.data;
  },

  // Create new template
  createTemplate: async (templateData) => {
    const response = await axiosInstance.post(
      `/api/admin/design-templates`,
      templateData
    );
    return response.data;
  },

  // Update template
  updateTemplate: async (templateId, templateData) => {
    const response = await axiosInstance.put(
      `/api/admin/design-templates/${templateId}`,
      templateData
    );
    return response.data;
  },

  // Delete template
  deleteTemplate: async (templateId) => {
    const response = await axiosInstance.delete(
      `/api/admin/design-templates/${templateId}`
    );
    return response.data;
  },

  // Apply template to events
  applyTemplateToEvents: async (templateId, eventIds) => {
    const response = await axiosInstance.post(
      `/api/admin/design-templates/${templateId}/apply`,
      { eventIds }
    );
    return response.data;
  },

  // Get template usage statistics
  getTemplateStats: async () => {
    const response = await axiosInstance.get(
      `/api/admin/design-templates/stats/usage`
    );
    return response.data;
  }
};

export const handleDesignApiError = (error) => {
  if (error.response) {
    const { status, data } = error.response;
    switch (status) {
      case 400:
        return data.message || 'Bad request. Please check your input.';
      case 401:
        return 'Unauthorized. Please log in again.';
      case 403:
        return 'Access denied. You do not have permission to perform this action.';
      case 404:
        return 'Template not found.';
      case 409:
        return data.message || 'Conflict. This action cannot be completed.';
      case 422:
        return data.message || 'Validation error. Please check your input.';
      case 500:
        return 'Server error. Please try again later.';
      default:
        return data.message || `Error ${status}: Something went wrong.`;
    }
  } else if (error.request) {
    return 'Network error. Please check your connection and try again.';
  } else {
    return error.message || 'An unexpected error occurred.';
  }
};

